import React from 'react';
import { useRecoilValue } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { Flex } from 'components/layout/Flex';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import PartNotFoundMessage from 'pages/NewCaseSearch/subcomponents/PartNotFoundMessage';
import { SelectPartMessage } from 'pages/NewCaseSearch/subcomponents/VisualComponents';
import { productSerialMessage } from './helpers';

const SerialNumberNotFound = () => {
  const { lookupResults, selectedResult, searchedPartNumber } = useRecoilValue(lookupState);
  const { serialNumber, product } = selectedResult;
  const headerCard = [{ title: 'Serial #:', value: serialNumber }];
  const serialNumberErrorMessage = productSerialMessage(product, serialNumber, searchedPartNumber);

  return (
    <Flex direction="column">
      {lookupResults.length > 1 ? null : (
        <Header
          title="Serial Number Not Found"
          subtitle={`We were not able to locate serial number ${serialNumber}. Please confirm the serial number specified is correct. If you believe this is in error, please specify the part number you want included in your RMA request.`}
          cards={headerCard}
          withLookup={true}
        />
      )}

      <Flex spacing="space-between">
        {product && !serialNumberErrorMessage && (
          <>
            <Flex direction="column" spacing="space-between" grow="1">
              <Product {...product} />
              <RmaFiels />
            </Flex>
            <WarrantyActions>
              <AddToRma />
            </WarrantyActions>
          </>
        )}

        {serialNumberErrorMessage && (
          <SelectPartMessage>
            <p>{serialNumberErrorMessage}</p>
          </SelectPartMessage>
        )}

        {!product && !searchedPartNumber && (
          <SelectPartMessage>
            <p>Please search for your part number to proceed</p>
          </SelectPartMessage>
        )}

        {!product && searchedPartNumber && <PartNotFoundMessage searchedPartNumber={searchedPartNumber} />}
      </Flex>
    </Flex>
  );
};

export default SerialNumberNotFound;
